import { Button } from '@mui/material';
import { IOrderStatus } from 'my-poppies-b2b-types';
import { useContext } from 'react';

import { colors } from '@/colors';
import { Container } from '@/components/Container';
import { OrderContext } from '@/contexts/OrderContext';
import useTranslation from '@/hooks/useTranslation';

interface IOrderRedirectButtonProps {
  orderId: string;
  customerId?: string | undefined;
  status: IOrderStatus;
}

export const OrderRedirectButton = ({ orderId, customerId, status }: IOrderRedirectButtonProps) => {
  const t = useTranslation();
  const { setShowRedirectForOrder } = useContext(OrderContext);

  return (
    <Container
      debugColor={'red'}
      sx={{ display: 'flex', alignItems: 'flex-start', flexGrow: 0, width: 'unset', margin: 'unset' }}
    >
      <Button
        onClick={() => {
          setShowRedirectForOrder({ orderId, customerId, orderStatus: status });
        }}
        sx={{ backgroundColor: colors.initialized, fontSize: 'min(12px, 3dvw)' }}
      >
        {t('general.redirect')}
      </Button>
    </Container>
  );
};
